export default "__VITE_ASSET__vbN8VVPv__"